import { render, staticRenderFns } from "./RejectReasonDlg.vue?vue&type=template&id=071bdb5c&scoped=true&"
import script from "./RejectReasonDlg.vue?vue&type=script&lang=js&"
export * from "./RejectReasonDlg.vue?vue&type=script&lang=js&"
import style0 from "./RejectReasonDlg.vue?vue&type=style&index=0&id=071bdb5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071bdb5c",
  null
  
)

export default component.exports